var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityPreferences = function SvgSecurityPreferences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8L18 0L36 8V20C36 31.1 28.32 41.48 18 44C7.68 41.48 0 31.1 0 20V8ZM32 21.98H18V4.38L4 10.6V22H18V39.86C25.44 37.56 30.94 30.22 32 21.98Z",
    fill: "black"
  })));
};
export default SvgSecurityPreferences;